import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { postData } from '../../utility/Utility';
import { toast } from 'react-toastify';
import CustomLoader from '../../Components/CustomLoader/CustomLoader';

export default function CategoryModal({ show, onClose, onSelect, selectedId = '' }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1
  });

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      const response = await postData('api/categories/list', {
        page: pagination.page,
        limit: pagination.limit,
        search: searchTerm
      });
      
      if (response?.status) {
        setCategories(response?.data || []);
        setPagination(prev => ({
          ...prev,
          total: response?.totalItems || 0,
          totalPages: response?.totalPages || 1
        }));
      } else {
        throw new Error(response.data?.message || 'Failed to fetch categories');
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          'Error loading categories'
      );
    } finally {
      setLoading(false);
    }
  }, [pagination.page, pagination.limit, searchTerm]);

  useEffect(() => {
    if (show) {
      fetchCategories();
    }
  }, [show, searchTerm, pagination.page, pagination.limit, fetchCategories]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchCategories();
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <form onSubmit={handleSearch} className="d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search categories..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">
              Search
            </button>
          </form>
        </div>
        
        <div className="table-responsive">
          <Table hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Image</th>
                <th>Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <CustomLoader loading={true} />
                  </td>
                </tr>
              ) : categories.length > 0 ? (
                categories.map((category, index) => (
                  <tr key={category._id} className={selectedId === category._id ? 'table-active' : ''}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={category?.image}
                        alt={category.title}
                        style={{ width: 50, height: 50, objectFit: 'cover' }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/path/to/default-image.png';
                        }}
                        className="rounded"
                      />
                    </td>
                    <td>{category.title}</td>
                    <td>{category.slug}</td>
                    <td>
                      <span className={`badge bg-${category.status === 'active' ? 'success' : 'danger'}`}>
                        {category.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => onSelect(category)}
                        disabled={selectedId === category._id}
                      >
                        {selectedId === category._id ? 'Selected' : 'Select'}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No categories found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
}
